import { render, staticRenderFns } from "./Source.component.vue?vue&type=template&id=aa1dd644&"
import script from "./Source.component.vue?vue&type=script&lang=js&"
export * from "./Source.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports